export default "__VITE_ASSET__bQKyuhsb__"